import _classCallCheck from "/opt/build/repo/postcard-editor/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/postcard-editor/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/postcard-editor/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/opt/build/repo/postcard-editor/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/opt/build/repo/postcard-editor/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/postcard-editor/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { LineSegmentsGeometry } from './LineSegmentsGeometry.js';

var LineGeometry = /*#__PURE__*/function (_LineSegmentsGeometry) {
  _inherits(LineGeometry, _LineSegmentsGeometry);

  function LineGeometry() {
    var _this;

    _classCallCheck(this, LineGeometry);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LineGeometry).call(this));
    _this.isLineGeometry = true;
    _this.type = 'LineGeometry';
    return _this;
  }

  _createClass(LineGeometry, [{
    key: "setPositions",
    value: function setPositions(array) {
      // converts [ x1, y1, z1,  x2, y2, z2, ... ] to pairs format
      var length = array.length - 3;
      var points = new Float32Array(2 * length);

      for (var i = 0; i < length; i += 3) {
        points[2 * i] = array[i];
        points[2 * i + 1] = array[i + 1];
        points[2 * i + 2] = array[i + 2];
        points[2 * i + 3] = array[i + 3];
        points[2 * i + 4] = array[i + 4];
        points[2 * i + 5] = array[i + 5];
      }

      _get(_getPrototypeOf(LineGeometry.prototype), "setPositions", this).call(this, points);

      return this;
    }
  }, {
    key: "setColors",
    value: function setColors(array) {
      // converts [ r1, g1, b1,  r2, g2, b2, ... ] to pairs format
      var length = array.length - 3;
      var colors = new Float32Array(2 * length);

      for (var i = 0; i < length; i += 3) {
        colors[2 * i] = array[i];
        colors[2 * i + 1] = array[i + 1];
        colors[2 * i + 2] = array[i + 2];
        colors[2 * i + 3] = array[i + 3];
        colors[2 * i + 4] = array[i + 4];
        colors[2 * i + 5] = array[i + 5];
      }

      _get(_getPrototypeOf(LineGeometry.prototype), "setColors", this).call(this, colors);

      return this;
    }
  }, {
    key: "fromLine",
    value: function fromLine(line) {
      var geometry = line.geometry;
      this.setPositions(geometry.attributes.position.array); // assumes non-indexed
      // set colors, maybe

      return this;
    }
  }]);

  return LineGeometry;
}(LineSegmentsGeometry);

export { LineGeometry };